import { useId } from 'react';
import { Button } from '@shared/components';
import { PermissionGuard } from '@/features/auth';

interface Props {
    disabledReason: string | null;
    onClick: () => void;
}

export function CreateInvoiceButton({ disabledReason, onClick }: Props) {
    const reasonId = useId();

    return (
        <PermissionGuard permission={{ resource: 'invoice', action: 'add' }}>
            <div className="flex flex-col items-end gap-1">
                <Button
                    type="button"
                    size="sm"
                    ariaDisabled={disabledReason !== null}
                    ariaDescribedBy={disabledReason ? reasonId : undefined}
                    onClick={onClick}
                >
                    Create invoice
                </Button>
                {disabledReason && (
                    <p id={reasonId} className="text-xs text-mp-muted">
                        {disabledReason}
                    </p>
                )}
            </div>
        </PermissionGuard>
    );
}
